import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./css/awarenessGame.css";
import useGameState from "../hooks/useGameState";
import useTranslation from "../hooks/useTranslation";

// Recursos
import edificos from "../assets/recursosJuego/EDIFICIOS-01.png";
import gameLogo from "../assets/recursosJuego/greenescape-logo.png";

// Importar todas las imágenes en WebP (más ligeras)
import img1 from "../assets/recursosJuego/1.webp";
import img2 from "../assets/recursosJuego/2.webp";
import img3 from "../assets/recursosJuego/3.webp";
import img4 from "../assets/recursosJuego/4.webp";
import img5 from "../assets/recursosJuego/5.webp";
import img6 from "../assets/recursosJuego/6.webp";
import img7 from "../assets/recursosJuego/7.webp";
import img8 from "../assets/recursosJuego/8.webp";
import img9 from "../assets/recursosJuego/9.webp";
import img10 from "../assets/recursosJuego/10.webp";
import img11 from "../assets/recursosJuego/11.webp";
import img12 from "../assets/recursosJuego/12.webp";
import img13 from "../assets/recursosJuego/13.webp";
import img14 from "../assets/recursosJuego/14.webp";
import img15 from "../assets/recursosJuego/15.webp";
import img16 from "../assets/recursosJuego/16.webp";
import img17 from "../assets/recursosJuego/17.webp";
import img18 from "../assets/recursosJuego/18.webp";

// Mapeo de números a imágenes
const imageMap = {
  1: img1, 2: img2, 3: img3, 4: img4, 5: img5, 6: img6,
  7: img7, 8: img8, 9: img9, 10: img10, 11: img11, 12: img12,
  13: img13, 14: img14, 15: img15, 16: img16, 17: img17, 18: img18
};

function AwarenessGame({ updateProgress }) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { selectedCharacters } = useGameState();
  const players = selectedCharacters?.playersArray || [];
  
  // Función helper para obtener el nombre traducido del personaje
  const getCharacterName = (characterId) => {
    return t(`characterSelection.characters.${characterId}.name`);
  };
  
  // Estado para manejar turnos, respuestas y preguntas
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [currentTurnIndex, setCurrentTurnIndex] = useState(0);
  const [playerAnswers, setPlayerAnswers] = useState({}); // { optionIndex: [player1, player2, ...] }
  const [showResults, setShowResults] = useState(false); // Para mostrar la respuesta correcta
  const [showTryAgainMessage, setShowTryAgainMessage] = useState(false); // Mensaje cuando nadie acierta

  // Array de todas las preguntas
  const questions = useMemo(
    () => [
      {
        id: 1,
        title: t('awarenessGame.questions.0.title'),
        text: t('awarenessGame.questions.0.text'),
        options: t('awarenessGame.questions.0.options'),
        correctAnswer: 1,
        image:1  
      },
      {
        id: 2,
        title: t('awarenessGame.questions.1.title'),
        text: t('awarenessGame.questions.1.text'),
        options: t('awarenessGame.questions.1.options'),
        correctAnswer: 3,
        image:2 , 
      },
      {
        id: 3,
        title: t('awarenessGame.questions.2.title'),
        text: t('awarenessGame.questions.2.text'),
        options: t('awarenessGame.questions.2.options'),
        correctAnswer: 2,
        image:3 , 
      },
      {
        id: 4,
        title: t('awarenessGame.questions.3.title'),
        text: t('awarenessGame.questions.3.text'),
        options: t('awarenessGame.questions.3.options'),
        correctAnswer: 0,
        image:4 , 
      },
      {
        id: 5,
        title: t('awarenessGame.questions.4.title'),
        text: t('awarenessGame.questions.4.text'),
        options: t('awarenessGame.questions.4.options'),
        correctAnswer: 1,
        image:5  
      },
      {
        id: 6,
        title: t('awarenessGame.questions.5.title'),
        text: t('awarenessGame.questions.5.text'),
        options: t('awarenessGame.questions.5.options'),
        correctAnswer: 2,
        image:6 , 
      },
      {
        id: 7,
        title: t('awarenessGame.questions.6.title'),
        text: t('awarenessGame.questions.6.text'),
        options: t('awarenessGame.questions.6.options'),
        correctAnswer: 1,
        image:7 , 
      },
      {
        id: 8,
        title: t('awarenessGame.questions.7.title'),
        text: t('awarenessGame.questions.7.text'),
        options: t('awarenessGame.questions.7.options'),
        correctAnswer: 0,
        image:8  
      },
      {
        id: 9,
        title: t('awarenessGame.questions.8.title'),
        text: t('awarenessGame.questions.8.text'),
        options: t('awarenessGame.questions.8.options'),
        correctAnswer: 1,
        image:9 , 
      },
      {
        id: 10,
        title: t('awarenessGame.questions.9.title'),
        text: t('awarenessGame.questions.9.text'),
        options: t('awarenessGame.questions.9.options'),
        correctAnswer: 3,
        image: 10, 
      },
      {
        id: 11,
        title: t('awarenessGame.questions.10.title'),
        text: t('awarenessGame.questions.10.text'),
        options: t('awarenessGame.questions.10.options'),
        correctAnswer: 1,
        image: 11 
      },
      {
        id: 12,
        title: t('awarenessGame.questions.11.title'),
        text: t('awarenessGame.questions.11.text'),
        options: t('awarenessGame.questions.11.options'),
        correctAnswer: 1,
        image: 12 
      },
      {
        id: 13,
        title: t('awarenessGame.questions.12.title'),
        text: t('awarenessGame.questions.12.text'),
        options: t('awarenessGame.questions.12.options'),
        correctAnswer: 1,
        image: 13 
      },
      {
        id: 14,
        title: t('awarenessGame.questions.13.title'),
        text: t('awarenessGame.questions.13.text'),
        options: t('awarenessGame.questions.13.options'),
        correctAnswer: 2,
        image: 14, 
      },
      {
        id: 15,
        title: t('awarenessGame.questions.14.title'),
        text: t('awarenessGame.questions.14.text'),
        options: t('awarenessGame.questions.14.options'),
        correctAnswer: 3,
        image: 15, 
      },
      {
        id: 16,
        title: t('awarenessGame.questions.15.title'),
        text: t('awarenessGame.questions.15.text'),
        options: t('awarenessGame.questions.15.options'),
        correctAnswer: 0,
        image: 16 
      },
      {
        id: 17,
        title: t('awarenessGame.questions.16.title'),
        text: t('awarenessGame.questions.16.text'),
        options: t('awarenessGame.questions.16.options'),
        correctAnswer: 0,
        image: 17, 
      },
      {
        id: 18,
        title: t('awarenessGame.questions.17.title'),
        text: t('awarenessGame.questions.17.text'),
        options: t('awarenessGame.questions.17.options'),
        correctAnswer: 1,
        image: 18, 
      },
    ],
    [t]
  );

  const currentQuestion = questions[currentQuestionIndex];

  // Función para manejar la selección de respuesta
  const handleAnswerSelect = (optionIndex) => {
    const currentPlayer = players[currentTurnIndex];
    
    // Verificar si el jugador ya ha votado
    const hasVoted = Object.values(playerAnswers).some((voters) =>
      voters.some((voter) => voter.characterId === currentPlayer.characterId)
    );

    if (hasVoted) {
      console.log("Este jugador ya ha votado");
      return;
    }
    
    // Agregar el jugador actual a la opción seleccionada
    const updatedAnswers = {
      ...playerAnswers,
      [optionIndex]: [...(playerAnswers[optionIndex] || []), currentPlayer],
    };
    
    setPlayerAnswers(updatedAnswers);

    // Avanzar al siguiente turno
    if (currentTurnIndex < players.length - 1) {
      setCurrentTurnIndex(currentTurnIndex + 1);
    } else {
      // Todos han respondido, esperar 1 segundo antes de verificar
      setTimeout(() => {
        // Verificar si algún jugador acertó la respuesta correcta
        const correctAnswerIndex = currentQuestion.correctAnswer;
        const playersWhoGotItRight = updatedAnswers[correctAnswerIndex] || [];
        const nobodyGotItRight = playersWhoGotItRight.length === 0;
        
        if (nobodyGotItRight) {
          // Nadie acertó - mostrar modal y reintentar
          setShowTryAgainMessage(true);
          
          // Esperar 3 segundos, cerrar modal y reiniciar para que vuelvan a votar
          setTimeout(() => {
            setShowTryAgainMessage(false);
            setPlayerAnswers({});
            setCurrentTurnIndex(0);
          }, 3000);
        } else {
          // Al menos 1 acertó - mostrar resultados y avanzar
          setShowResults(true);
          
          // Después de mostrar resultados, esperar 5 segundos y pasar a la siguiente pregunta
          setTimeout(() => {
            if (currentQuestionIndex < questions.length - 1) {
              // Pasar a la siguiente pregunta
              setCurrentQuestionIndex(currentQuestionIndex + 1);
              setCurrentTurnIndex(0);
              setPlayerAnswers({});
              setShowResults(false);
            } else {
              // Se terminaron todas las preguntas
              console.log("¡Juego terminado! Navegando a Awareness Wrap-Up...");
              updateProgress('game');
              navigate('/awareness-wrapup');
            }
          }, 5000);
        }
      }, 1000);
    }
  };

  return (
    <div className="awareness-game-wrapper">
      {/* Modal cuando nadie acierta */}
      {showTryAgainMessage && (
        <div className="try-again-modal-overlay">
          <div className="try-again-modal">
            <p className="try-again-modal-text">{t('awarenessGame.tryAgainMessage')}</p>
          </div>
        </div>
      )}
      
      <div className="awareness-game-layout">
        {/* Sidebar izquierda */}
        <aside className="game-sidebar">
          <div className="fraction">
            <div className="big">{currentQuestion.id}</div>
            <div className="small">/ {questions.length}</div>
          </div>
          <div className="mode">{t('awarenessGame.mode')}</div>
          <ul className="turn-list">
            {players.map((p, idx) => (
              <li
                key={p.characterId}
                className={`turn-item ${idx === currentTurnIndex ? "active" : ""}`}
              >
                <div className="turn-item-content">
                  <img className="turn-avatar" src={p.image} alt={getCharacterName(p.characterId)} />
                  <div className="turn-text-container">
                    {idx === currentTurnIndex && (
                      <div className="turn-label">{t('awarenessGame.turnLabel')}</div>
                    )}
                    <span className="turn-name">{getCharacterName(p.characterId)}</span>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </aside>

        {/* Zona principal */}
        <main className="game-main">
          <div className="hero">
            <img src={imageMap[currentQuestion.image]} alt="Hero" className="hero-img" />
            <img src={edificos} alt="Skyline" className="hero-skyline" />
          </div>
        </main>
      </div>

      {/* Franja inferior de pregunta - ancho completo */}
      <section className="question-strip">
        <div className="qs-grid">
          <div className="qs-left">
            <img src={gameLogo} alt="GreenScape" className="qs-logo" />
          </div>
          <div className="qs-right">
            <p className="q-text">{currentQuestion.text}</p>
            
            <div className="answers-grid">
              {currentQuestion.options.map((opt, idx) => {
                const isCorrect = idx === currentQuestion.correctAnswer;
                
                return (
                  <div key={idx} className="answer-container">
                    <button 
                      className={`answer-btn ${showResults && isCorrect ? 'correct-answer' : ''}`}
                      onClick={() => handleAnswerSelect(idx)}
                      disabled={showResults || currentTurnIndex >= players.length}
                    >
                      {opt}
                      {showResults && isCorrect && <span className="correct-icon"> ✓</span>}
                    </button>
                    {/* Avatares de jugadores que seleccionaron esta opción */}
                    {playerAnswers[idx] && playerAnswers[idx].length > 0 && (
                      <div className="answer-avatars">
                        {playerAnswers[idx].map((player, pIdx) => (
                          <img
                            key={pIdx}
                            src={player.image}
                            alt={getCharacterName(player.characterId)}
                            className="answer-avatar"
                            title={getCharacterName(player.characterId)}
                          />
                        ))}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default AwarenessGame;
